<template>
  <div>
    <!-- Fascia con video di sfondo -->
    <div class="banner-bg">
      <video
        ref="bgVideo"
        class="bg-video"
        autoplay
        muted
        loop
        playsinline
      >
        <!-- Sorgente principale (QuickTime MOV) -->
        <source :src="videoSrc" type="video/mp4" />
         Il tuo browser non supporta l'elemento video.
      </video>
      <!-- Overlay semitrasparente per leggibilità eventuale testo sovrapposto -->
      <div class="video-overlay"></div>
    </div>

    <div class="text-black bg-white pt-5 pb-5">
      <div class="container">
        <div class="h1">
          La valle
          <br />
        </div>

        <!-- Citazioni storiche della Valle di Comino: griglia responsiva -->
        <div class="row mt-4 justify-content-center">
          <div class="col-12 col-lg-6 order-lg-1">
            <div class="cite poetry">
      			Questa Valle anticamente è stata chiamata Cominio…confina
				da la parte d’Oriente con l’Abruzzo et spetialmente con Opi, Civitella et
				altri Castelli…Da Occidente co’l Stato di Sora, et d’Arpino…è distante
				da Roma circa 60 miglia, et altre tanto da Napoli…
			  <br />
			  <br />
					E’ dotato tutto lo Stato d’aria perfettissima, di buono, bello, et
					fertile Territorio, abbondante di grani, orzi, migli, legumi, lini, canape: di
					frutti diversi, di vini dedicati et saporiti… Il Fibreno produce il singolar
					pesce detto carpione che in Italia non nasce altrove…
			  <br />
			  <br />
						Vi sono persone qualificate di lettere, di mercatura et anche fra’
						loro vi è qualche Barone di Castelli…Il Signore hà in questo Stato di
						molte fabbriche; et fortezze d’importanza
			  <br />
			  <br />
					<span class="quote"> da Relatione familiare de lo Stato d’Alvito fatta a l’llmo sig.re Card.le di Como, 1595 </span>
            </div>
          </div>

          <div class="col-12 col-lg-6 order-lg-2">
            <div class="cite poetry">
			        …una contrada, per stare su quei monti asperi, amenissima, chiamata hoggi Comino: ella è attorniata da monti altissimi, ha da 8 castella ben popolate, Vicaglio,
			        Alvito, S. Donato, Sette frati, Picinisco, Gallinaro e Casalviero: questa contrada fu dagli antichi chiamata Cominio, da una città che v’era così detta,
			        della quale non sanno i paesani render alcun conto dove ella fusse, e di lei fa Livio menzione. In quella medesima contrada a man
			        dritta sotto i monti è Atina, città antichissima, a lato della quale scorre il fiume Melfa, che nasce nell’Appennino, e va a mescolarsi co’l Garigliano
			        presso a Pontecorvo: di questa città fa Vergilio menzione, e Livio medesimamente
			        <br />
				    <br />
					<span class="quote"> a metà del XV secolo, scrive lo storico Flavio Biondo </span>
            </div>
          </div>

          <div class="col-12 col-lg-6 order-lg-3">
             <div class="cite">
             		La Valle di Comino, una storia di confine.<br />
					Ci vuole tempo per capirla, la Valle di Comino. Dopo qualche giorno il suo profilo si delinea con più precisione, la
					linea montuosa che ne disegna il contorno si fa più familiare e ci si orienta con più sicurezza tra le strade che
					scendono e risalgono da un paese all’altro. Dalle terrazze panoramiche dei borghi, ognuno con la propria
					prospettiva, si riconoscono le fisionomie degli altri, ciascuno col suo modo unico di tenersi aggrappato alla terra.
				<br />
					Si inizia ad intuire l’orgoglio della Terra di Mezzo. Qui non troverete attrattive imperdibili ma, piazza dopo piazza,
					vicolo dopo vicolo, dalla somma delle piccole identità si svelerà una magia sottile, che nessuno dei suoi luoghi, da
					solo, può raccontare. Per capirla bisogna attraversarla. Come fecero i Sanniti, e come loro i Romani, i Longobardi, i Normanni, nobili e
					pellegrini, soldati e scrittori.
				<br />
					E questo piccolo lembo di terra al confine di tre regioni, microcosmo di tante realtà, oggi proprio nel paesaggio si
					riscopre Valle.
				<br />
				<br />
				<span class="quote"> Vittorio Macioce, Turismo Culturale – La Valle di Comino Incantata, Vanni Editore </span>
			 </div>
          </div>

          <div class="col-12 col-lg-6 order-lg-4">
             <div class="cite">
			 	  …laboriosa e schiva, rude e costante, fattiva e discreta secondo il carattere delle genti ciociare.
			 	<span class="quote"> su Atina e le sue genti, Paolo Bertolini</span>
			 </div>
          </div>

        </div>
      </div>
    </div>
    <div class="txt-black bg-light text-black pt-5 pb-5">
      <div class="container">
        <div class="h1" id="sitoweb">Questo sitoweb</div>
        <div>
          <br />Questo sitoweb vuole essere di aiuto alle comunità locali, implementando un servizio online di geolocalizzazione,
          cerca di condividere valori e principi della Valle di Comino, dei suoi abitanti, della loro identità che tutti si tengono ben stretti.
          <br />
          <br />
			  Il primo passo per conseguire quest'obiettivo è la conoscenza delle attività produttive sul territorio in tutti
	          i suoi molteplici aspetti e tradizioni. La presenza online tramite geolocalizzazione delle attrattive del territorio, delle economie sviluppate in zona, consente di utilizzare la diffusione dei contenuti sul web per veicolare
	          e promuovere iniziative locali, e permette una ricaduta positiva generata dall'effetto rete sull'azienda e sulle altre che geolocalizzano sul portale della "Valle di Comino".
	          <br />
	          <br />
	          La Valle di Comino è una terra che porta il peso del tempo nel modo più discreto possibile, senza apparire, voi che la visiterete non troverete una meraviglia che da sola valga il
	          prezzo del biglietto, ma è magia a portata di mano, è stupore e sorpresa, nei vicoli dei borghi aggrappati alle pendici appenniniche, nei sapori del formaggio, nell'olio, nei vini, nei frutti della terra,
	          nel suono di una zampogna che risuona nella stessa valle dove passarono i Sanniti e i Romani, sulle cime delle montagne che la cingono, dove venne tracciata la linea Gustav della II guerra mondiale.
	          <br />
	          <br />
	          Una comunità, quella della valle, che si è accorta di rischiare di diventare un ricordo. Di vivere di nostalgia, i giovani partono verso Roma, verso il nord, le case rimangono vuote, gli emigrati non tornano, i campi lavorati si restringono.
	          È la storia di tanti paesi italiani di montagna, dei comuni delle "aree interne", ma la Valle di Comino ha qualcosa di particolare:
	          quella posizione sospesa tra Roma e Napoli, confine di Lazio, Abruzzo e Molise, che l'ha resa per secoli una terra di passaggio e di frontiera, oggi è la sua più silenziosa attrattiva.
	          Non appartiene del tutto a nessuno, eppure è il cuore di tutto. Un'area ben definita quella della Valle di Comino, che apre a grandi potenzialità che se ben utilizzate offrono l'occasione per sperimentare l'effetto rete,
	          l'unione fa la forza, capace di orientare le scelte dei consumatori, contribuire ad affermare un marchio, far crescere la qualità della vita e le prospettive di occupazione delle popolazioni locali, fermare la dipartita.
	          <br />
	          <br />
	          Oggi esiste una strategia basata sull'associazionismo, la gestione associata dei servizi (tecnici comunali, ragioneria, catasto, scuola omnicomprensivo, centrale unica di committenza,
	          raccolta differenziata, polizia locale, sportello unico attività produttive, comunità montana). 17 sindaci di piccoli comuni, dove ci si conosce tutti, dove le rivalità campanilistiche hanno radici antiche che si siedono insieme
	          e decidono di guardare oltre il proprio confine comunale per ridurre il calo demografico, assicurare i servizi per la salute (ASL locale), migliorare il trasporto locale, favorire lo sviluppo delle aziende e l'occupazione sul territorio.
	          È un gesto quasi controcorrente rispetto ai tempi, un atto di umiltà collettiva.
	          <br />
	          <br />
	          Nel profondo è un tentativo di fermare una perdita, un'emorraggia lenta. Non solo economica, ma di memoria, di identità, di quell'intreccio fragile tra il paesaggio, le montagne e la comunità che rende quel luogo vivo.
	          La sfida delle aree interne rimane aperta ma la Valle di Comino ha qualcosa che molte altre non hanno: la consapevolezza della propria bellezza e la testardaggine di chi ha deciso che vale la pena restare.
	          <br />
	          <br />
	        </div>
	      </div>
	    </div>

	    <div class="container d-none d-sm-block">
	      <div class="row pt-5 pb-5">
	        <div class="col-8 text-left align-self-center">
	          <div class="h3">Vogliamo aiutare le aziende della nostra valle, noi ci crediamo. E tu?</div>
	          <div class="row mt-4">
	            <div class="col-4 mr-4 pr-0">
	              <b-button variant="dark" class="text-white btn-style" to="/registrati">Registra la tua attività</b-button>
	            </div>
	            <div class="col-4">
	              <b-button variant="success" class="btn-block btn-style" to="/mappa">Cerca un'attività</b-button>
	            </div>
	          </div>
	        </div>
	      </div>
	    </div>
	    <div class="container d-block d-sm-none">
	      <div class="row pt-5 pb-5">
	        <div class="col-12 text-left align-self-center">
	          <div class="h3">Vogliamo aiutare le aziende della nostra valle, noi ci crediamo. E tu?</div>
	        </div>
	        <div class="col-12">
	          <div class="row mt-4">
	            <div class="col-6">
	              <b-button variant="dark" class="text-white btn-style" to="/registrati">Registra la tua attività</b-button>
	            </div>
	            <div class="col-6">
	              <b-button variant="success" class="btn-block btn-style" to="/mappa">Cerca un'attività'</b-button>
	            </div>
	          </div>
	        </div>
	      </div>
	    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "WhoWeAre",
  data() {
    return {
      today: moment().format("DD/MM/YYYY"),
      videoSrc: require("@/assets/mov/6057.mp4")
    };
  }
};
</script>

<style scoped>
a,
a:hover,
a:visited {
  text-decoration: none;
  color: white;
}

.banner-bg {
  height: 650px;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.bg-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  z-index: 0;
}

.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.35);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>